var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-class"},[_c('fulfilling-bouncing-circle-spinner',{attrs:{"animation-duration":4000,"size":60,"color":"#0093DD"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }